import { render, staticRenderFns } from "./ParentMenuGroup.vue?vue&type=template&id=ae6530d4"
import script from "./ParentMenuGroup.vue?vue&type=script&lang=js"
export * from "./ParentMenuGroup.vue?vue&type=script&lang=js"
import style0 from "./ParentMenuGroup.vue?vue&type=style&index=0&id=ae6530d4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports